import { render } from "./manage_sections.html?vue&type=template&id=7f99f676&external"
import script from "./manage_sections.js?vue&type=script&lang=js&external"
export * from "./manage_sections.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__